<template>
    <div>
        <div v-if="showhead" class="assets-title">
            <div class="title-line"></div>
            <span class="title-content">组合投资</span>
            <span style="font-size: 14px; color: #999999">截至日期 {{ date }}</span>
        </div>
        <div v-if="showhead" class="assets-info">
            <div v-for="(item, index) in amountTypes" :key="index" class="assets-item">
                <div class="amount-type">{{ item.text }}</div>
                <div v-if="index == 0" class="assets-text">{{ $util.fmtNum(item.val) }}</div>
                <div
                    v-else
                    class="assets-text"
                    :class="item.val > 0 ? 'add' : item.val < 0 ? 'reduce' : ''"
                >
                    {{ $util.fmtNum(item.val) }}
                </div>
            </div>
        </div>
        <el-row v-if="assets.length <= 0 && hasLoad" class="no-funds">
            <el-col :span="12" :offset="8">
                <span class="no-funds-img" />
                <div class="no-funds-box">
                    <p>暂无数据</p>
                </div>
            </el-col>
        </el-row>
        <el-table
            v-else-if="hasLoad"
            :data="assets"
            style="width: 100%"
            class="tab-list-tit"
            :header-cell-style="{ background: 'var(--bg-color-lightest)' }"
        >
            <el-table-column label="产品名称" width="280" class-name="fund-offset">
                <template slot-scope="scope">
                    <div class="fund-name">
                        {{ `${scope.row.strategyname}(${scope.row.strategycode})` }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="交易账号" align="center">
                <template slot-scope="scope">
                    <span>{{ scope.row.tradeacco }}</span>
                </template>
            </el-table-column>
            <el-table-column label="持仓金额(元)" align="center">
                <template slot-scope="scope">
                    <span>{{ $util.fmtNum(scope.row.marketvalue) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="昨日收益(元)" align="center">
                <template slot-scope="scope">
                    <span
                        :class="
                            scope.row.yestincome > 0
                                ? 'add'
                                : scope.row.yestincome < 0
                                ? 'reduce'
                                : ''
                        "
                    >
                        {{ $util.fmtNum(scope.row.yestincome) }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="持有收益(元)" align="center">
                <template slot-scope="scope">
                    <span
                        :class="
                            scope.row.totalincome > 0
                                ? 'add'
                                : scope.row.totalincome < 0
                                ? 'reduce'
                                : ''
                        "
                    >
                        {{ $util.fmtNum(scope.row.totalincome) }}
                    </span>
                </template>
            </el-table-column>
            <!-- <el-table-column label="持有收益率" align="center">
                <template slot-scope="scope">
                    <span
                        :class="
                            scope.row.currentprofitrate > 0
                                ? 'add'
                                : scope.row.currentprofitrate < 0
                                  ? 'reduce'
                                  : ''
                        "
                    >
                        {{ $util.fmtNum(scope.row.currentprofitrate)
                        }}{{ scope.row.currentprofitrate ? "%" : "" }}
                    </span>
                </template>
            </el-table-column> -->
            <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                    <el-button
                        type="text"
                        plain
                        size="small"
                        style="color: #1890ff; font-weight: normal"
                        v-on:click.stop="showDetail(scope.row)"
                    >
                        查看调仓记录
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-row v-if="allPage > 0">
            <el-pagination
                :page-size="Number(conf.PAGE_SIZE)"
                :current-page.sync="curPage"
                layout="->, total, prev, pager, next"
                :total="Number(allPage)"
                v-on:current-change="newAssets"
            />
        </el-row>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import fundApi from "@/api/fund";
import format from "date-fns/format";

export default {
    name: "MyAssets",
    components: {},
    mixins: [mixin],
    props: {
        showhead: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            conf: {}, // 初始化配置文件内容
            searchText: "", // 搜索文本内容
            allAssets: {}, // 资产汇总信息
            assets: [], // 资产列表
            queryFind: null, // 定时器
            allPage: "0", // 所有数据条数
            pagecount: 10, // 分页条数
            pageoffset: 1, // 起始页
            amountTypes: [
                {
                    text: "总市值(元)",
                    val: ""
                },
                {
                    text: "昨日收益(元)",
                    val: ""
                },
                {
                    text: "持仓收益(元)",
                    val: ""
                }
            ], // 金额类型
            curPage: 1, // 当前页
            date: "", // 当前日期
            hasLoad: false // 是否已经查询数据
        };
    },
    watch: {},
    mounted() {
        this.conf = this.$util.getConfig().const;
        this.date = this.$util.fmtDate(format(new Date(), "YYYYMMDD"));
    },
    methods: {
        // 获取新一页数据
        newAssets(val) {
            this.pageoffset = val;
            this.doAction();
        },
        // 对基金频繁查询请求做处理
        doAction() {
            const _this = this;
            clearTimeout(this.queryFind);
            this.queryFind = setTimeout(function () {
                _this.getAssets();
            }, 300);
        },
        // 获取资产信息
        async getAssets() {
            if (!this.$cache.getBinded()) {
                return;
            }
            const res = await fundApi.qryStrategyAsset({
                pageSize: this.pagecount,
                pageNum: this.pageoffset
            });
            this.hasLoad = true;
            if (res.data) {
                this.allAssets = res.data.first ? res.data.first : {};
                const array = res.data.returnList ? res.data.returnList : [];
                this.amountTypes[0].val = this.allAssets.marketvalue;
                this.amountTypes[1].val = this.allAssets.yestincome;
                this.amountTypes[2].val = this.allAssets.totalincome;
                if (this.pageoffset == 1) {
                    this.curPage = 1;
                }
                this.assets = array;
                this.allPage = res.data.total ? res.data.total.toString() : "0";
            }
        },
        // 格式化涨跌幅数据
        formatterRate(rate) {
            if (!rate) {
                return "--";
            }
            const prefix = Number(rate) > 0 ? "+" : "";
            return prefix + this.$util.fmtNum(rate) + "%";
        },
        // 跳转到详情
        showDetail(item) {
            this.$router.push({
                name: "comboAssetsDetail",
                query: { strategycode: item.strategycode }
            });
        }
    }
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/varibles";
.assets-title {
    display: flex;
    align-items: center;
    margin: 13px 0 20px 0;
}
.assets-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 30px;
    border-bottom: solid 1px #f1f1f1;

    .assets-item {
        width: 30%;
        height: 110px;
        border-radius: 6px;
        background: #ffffff;
        box-sizing: border-box;
        border: 1px solid #d9d9d9;
        padding-top: 20px;
        padding-left: 32px;

        .amount-type {
            font-size: 14px;
            color: #333333;
            margin-bottom: 10px;
        }
        .assets-text {
            font-size: 32px;
            font-weight: 500;
            color: #000000;
        }
        .add {
            color: $risk5;
        }
        .reduce {
            color: $risk1;
        }
    }
}
.line {
    background: #e8e8e8;
    width: 1px;
    height: 12px;
}
.fund-name {
    color: #333333;
    // font-weight: bold;
    font-size: 14px;
}
.el-table td.el-table__cell div {
    color: #333333;
}
.el-table td.el-table__cell span {
    color: #333333;
    &.add {
        color: $risk5;
    }
    &.reduce {
        color: $risk1;
    }
}
.el-table {
    border: 1px solid #f1f1f1;
}
.el-button.is-plain:hover,
.el-button.is-plain:focus {
    background-color: transparent;
    border-color: transparent;
}
.el-pagination {
    margin-bottom: 0;
}
</style>
